import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import CloseIcon from 'components/atoms/icons/closeIcon';

const ModalPopup = ({ title, isOpen, toggle, children, ...rest }) => {
  const modalToggle = () => toggle(!isOpen);

  const closeButton = (
    <button className="close" onClick={modalToggle}>
      <CloseIcon />
    </button>
  );

  return (
    <Modal isOpen={isOpen} toggle={modalToggle} {...rest}>
      <ModalHeader toggle={modalToggle} close={closeButton}>
        {title}
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};

ModalPopup.defaultProps = {
  isOpen: false,
};

ModalPopup.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.object,
};

export default ModalPopup;
